import React from 'react'
import './Lifes.css'

export const Lifes = (props: any) => {

    return (
        <div className='Lifes'>
            <div className="div-animated-number">
                <span className='lifes-span'>{props.lifes > 0 ? props.lifes + "00 HP" : "DEAD"}</span>
            </div>
            <div className="progress-bar">
            {Array.from({ length: props.maxLifes }, (_, index) => (
                <div
                key={index}
                className={`progress-segment ${index < props.lifes ? 'filled'+props.lifes : 'hidden'} ${index === props.maxLifes-1 ? 'firstLife' : ''} ${index === 0 ? 'lastLife' : ''}`}
                >
                </div>
            ))}
            </div>
        </div>
    )
}
